module.exports = __webpack_public_path__ + "img/logo-ledesma-white.fdefc1ec.png";